<template>
	<div>
		<div v-if="!loading">
			<div v-if="!eBoekhouden">
				<div class="vx-row">
					<div class="vx-col w-full mb-base">
						<vx-card title="E-boekhouden">
							<template slot="actions">
								<vx-tooltip class="flex" text="Hoe en wat?">
									<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
								</vx-tooltip>
							</template>
							<div class="vx-row w-full">
								<div class="vx-col lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Gebruikersnaam"
											  v-model="EboekhoudenCreateData.username"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Beveiligingscode 1"
											  v-model="EboekhoudenCreateData.security_code_1"></vs-input>
								</div>
								<div class="vx-col sm:w-full lg:w-1/3 md:w-1/3 w-full">
									<vs-input label="Beveiligingscode 2"
											  v-model="EboekhoudenCreateData.security_code_2"></vs-input>
								</div>
								<div class="vx-col w-full"><br></div>
								<div class="vx-col w-full">
									<vs-button @click.native="createEboekhouden()">Acount koppelen</vs-button>
								</div>
								<div class="vx-col w-full">
									<label>Wanneer je op "opslaan" klikt ga je akkoord met de maandelijkse kosten van
										6,99 voor gebruik van de
										e-boekhouden
										koppeling.</label>
								</div>
							</div>
						</vx-card>
					</div>
				</div>
			</div>

			<div v-else>
				<div class="vx-row">
					<div class="vx-col w-full mb-base">
						<vx-card title="Gegevens" toolTip tool-tip-text="Hoe en wat?" customActionIcon
								 @click-icon="wiki" icon="question-circle">
							<div class="vx-row w-full">
								<div class="vx-col lg:w-1/3 md:w-1/3 w-full">
									<vs-input disabled="true" label="Gebruikersnaam" name="eUserName"
											  v-model="selectedEboekhouden.username"></vs-input>
								</div>
								<div class="vx-col lg:w-1/3 md:w-1/3 w-full">
									<vs-input disabled="true" label="Beveiligingscode 1" name="eSecurityCode"
											  v-model="selectedEboekhouden.security_code_1"></vs-input>
								</div>
								<div class="vx-col lg:w-1/3 md:w-1/3 w-full">
									<vs-input disabled="true" label="Beveiligingscode 2" name="eSecurityCode2"
											  v-model="selectedEboekhouden.security_code_2"></vs-input>
								</div>

								<div class="vx-col lg:w-3/12 md:w-3/12 w-full">
									<vs-input type="number" label="Rekening code" v-validate="'required|max:9'"
											  name="accounting_code"
											  v-model="selectedEboekhouden.accounting_code"></vs-input>
									<span class="text-danger text-sm" v-show="errors.has('accounting_code')">{{
											errors.first('accounting_code')
										}}</span>
								</div>
								<div class="vx-col lg:w-3/12 md:w-3/12 w-full">
									<vs-input label="Kostenplaats" v-validate="'required'" name="cost_center"
											  v-model="selectedEboekhouden.cost_center"></vs-input>
									<span class="text-danger text-sm" v-show="errors.has('cost_center')">
										{{ errors.first('cost_center') }}</span>
								</div>
								<div class="vx-col lg:w-6/12 md:w-6/12 w-full">
									<label class="multiselect-label">BTW</label>
									<vue-multiselect
										placeholder="Selecteer BTW"
										v-model="btwOptions.selected"
										:options="btwOptions.options"
										:show-labels="false"
										:allow-empty="false"
										track-by="name" label="name"
									/>
									<span class="text-danger text-sm" v-show="errors.has('selectedBtw')">
										{{ errors.first('selectedBtw') }}</span>
								</div>
							</div>
						</vx-card>
					</div>

					<div class="vx-col w-full mb-base">
						<vx-card title="Factuur">
							<div class="vx-row">
								<div class="vx-col w-full">Hieronder kun je de naam invullen van het factuursjabloon dat
									je wilt gebruiken
								</div>
								<div class="vx-col w-full">
									<vs-input label="Factuur Sjabloon" v-validate="'required'" name="invoice_pattern"
											  v-model="selectedEboekhouden.invoice_pattern"></vs-input>
								</div>
								<div class="vx-col w-full"><span class="text-danger text-sm"
																 v-show="errors.has('invoice_pattern')">{{
										errors.first('invoice_pattern')
									}}</span></div>
							</div>
						</vx-card>
					</div>
					<div class="vx-col w-full mb-base">
						<vx-card title="Factuur email">
							<div class="vx-row w-full">
								<div class="vx-col w-full">Je kunt voor volgende optie's kiezen om het factuur per
									bestelling uniek te maken.
								</div>
								<div class="vx-col w-full">Dit doe je door een van de volgende optie's te omsluiten met
									"[ ]"
								</div>
								<div class="vx-col w-full ml-12">
									<ul>
										<li>[klant_naam] voor de naam van de klant.</li>
										<li>[bestellings_id] voor het id van de bestelling.</li>
									</ul>
								</div>

								<div class="vx-col lg:w-3/12 md:w-3/12 w-full">
									<vs-input v-validate="'required'" name="email_subject"
											  v-model="selectedEboekhouden.email_subject"
											  label="Email onderwerp"></vs-input>
									<span class="text-danger text-sm" v-show="errors.has('email_subject')">
										{{ errors.first('email_subject') }}</span>
								</div>

								<div class="vx-col lg:w-4/12 md:w-4/12 w-full">
									<vs-input v-validate="'required|email'" name="email_from"
											  v-model="selectedEboekhouden.email_from"
											  label="Emailadres afzender"></vs-input>
									<span class="text-danger text-sm" v-show="errors.has('email_from')">
										{{ errors.first('email_from') }}</span>
								</div>

								<div class="vx-col lg:w-5/12 md:w-5/12 w-full">
									<label class="multiselect-label">Standaard email versturen</label>
									<vue-multiselect
										placeholder="Maak een keuze"
										v-model="emailOptions.selected"
										:options="emailOptions.options"
										:show-labels="false"
										:allow-empty="false"
										track-by="name"
										label="name"
									/>
									<span class="text-danger text-sm" v-show="errors.has('selectedBtw')">
										{{ errors.first('selectedBtw') }}</span>
								</div>

								<div class="vx-col w-full">
									<label class="smallLabel">Email bericht</label>
									<vs-textarea height="300px" v-validate="'required'" name="email_message"
												 v-model="selectedEboekhouden.email_message"></vs-textarea>
									<span class="text-danger text-sm" v-show="errors.has('email_message')">
										{{ errors.first('email_message') }}</span>
								</div>
							</div>
							<div class="vx-col w-full">
								<vs-button @click.native="updateEboekhouden()">Wijzigingen opslaan</vs-button>
							</div>
						</vx-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';
import vSelect from 'vue-select';

Vue.use(VeeValidate);
Vue.use(VeeValidate);
const dict = {
	custom: {
		email_message: {
			required: 'Voer een e-mail bericht in',
		},
		email_from: {
			required: 'Voer een e-mailadres in',
			email: 'Dit is geen geldig e-mailadres',
		},
		email_subject: {
			required: 'Voer een e-mail onderwerp in',
		},
		invoice_pattern: {
			required: 'Voer een factuur Sjabloon in',
		},
		selectedBtw: {
			required: 'Maak een keuze',
		},
		cost_center: {
			required: 'Voer je kostenplaats in',
		},
		accounting_code: {
			required: 'Voer je rekening code in',
			max: 'Een rekening code is maximaal 9 cijfers lang'
		},

	}
};
Validator.localize('en', dict);

export default {
	name: 'module-accounting-eboekhouden',
	data() {
		return {
			loading: true,
			selectedEboekhouden: {},
			emailOptions: {
				selected: {},
				options: [
					{
						name: 'nee, ik verstuur ze handmatig',
						toApi: 0,
					}, {
						name: 'Ja, verstuur automatisch',
						toApi: 1,
					},
				]
			},
			btwOptions: {
				selected: {},
				options:
					[
						{
							name: 'BTW hoog, verkopen 21%',
							toApi: 'HOOG_VERK_21',
						},
						{
							name: 'BTW hoog, verkopen 19%',
							toApi: 'HOOG_VERK',
						},
						{
							name: 'BTW laag, verkopen 9%',
							toApi: 'LAAG_VERK',
						},
						{
							name: 'BTW Verlegd 0% (1e op de btw-aangifte)',
							toApi: 'VERL_VERK',
						},
						{
							name: 'Leveringen naar buiten de EU 0%',
							toApi: 'BU_EU_VERK',
						},
						{
							name: 'Goederen naar binnen de EU 0%',
							toApi: 'BI_EU_VERK',
						},
					],
			},
			EboekhoudenCreateData: {
				username: '',
				security_code_1: '',
				security_code_2: '',
			},
		}
	},
	mounted() {
		this.$vs.loading();
		this.init()
	},
	computed: {
		...mapGetters({
			eBoekhouden: 'eBoekhouden/eBoekhouden',
		})
	},
	methods: {
		...mapActions({
			Settings: 'eBoekhouden/getEboekhouden'
		}),
		init() {
			this.$store.dispatch('eBoekhouden/init').then(res => {
				this.selectedEboekhouden = {...this.$store.state.eBoekhouden.eBoekhouden};
				if (this.selectedEboekhouden) {
					this.setBtw();
					this.setEmail();
				}
				this.$vs.loading.close();
				this.loading = false;
			})
		},
		setBtw() {
			if (this.selectedEboekhouden.btw_code) {
				if (this.selectedEboekhouden.btw_code.includes('HOOG_VERK_21')) {
					this.btwOptions.selected = this.btwOptions.options[0];
				} else if (this.selectedEboekhouden.btw_code.includes('HOOG_VERK')) {
					this.btwOptions.selected = this.btwOptions.options[1];
				} else if (this.selectedEboekhouden.btw_code.includes('LAAG_VERK')) {
					this.btwOptions.selected = this.btwOptions.options[2];
				} else if (this.selectedEboekhouden.btw_code.includes('VERL_VERK')) {
					this.btwOptions.selected = this.btwOptions.options[3];
				} else if (this.selectedEboekhouden.btw_code.includes('BU_EU_VERK')) {
					this.btwOptions.selected = this.btwOptions.options[4];
				} else if (this.selectedEboekhouden.btw_code.includes('BI_EU_VERK')) {
					this.btwOptions.selected = this.btwOptions.options[5];
				}
			}
			this.$vs.loading.close();
		},
		setEmail() {
			if (this.selectedEboekhouden.send_email === 0) {
				this.emailOptions.selected = this.emailOptions.options[0];
			} else if (this.selectedEboekhouden.send_email === 1) {
				this.emailOptions.selected = this.emailOptions.options[1];
			}
		},
		createEboekhouden() {
			this.$vs.loading();
			this.$store.dispatch('eBoekhouden/createEboekhouden', this.EboekhoudenCreateData).then(res => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je account is gekoppeld',
					color: 'success'
				});
				this.init();
			}).catch(error => {
				this.$vs.loading.close();
				this.$vs.notify({
					title: 'Oops',
					text: 'Je gegevens zijn niet gevonden',
					color: 'danger'
				});
			});
		},
		updateEboekhouden() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$vs.loading();
					const updateParams = {
						accounting_code: this.selectedEboekhouden.accounting_code,
						cost_center: this.selectedEboekhouden.cost_center,
						invoice_pattern: this.selectedEboekhouden.invoice_pattern,
						email_subject: this.selectedEboekhouden.email_subject,
						email_from: this.selectedEboekhouden.email_from,
						email_message: this.selectedEboekhouden.email_message,
						send_email: this.emailOptions.selected.toApi,
					};
					if (this.btwOptions.selected) {
						updateParams.btw_code = this.btwOptions.selected.toApi;
					}
					if (this.emailOptions.selected) {
						updateParams.send_email = this.emailOptions.selected.toApi;
					}
					this.$store.dispatch('eBoekhouden/updateEboekhouden', updateParams).then(res => {
						this.$vs.notify({
							title: 'Gelukt',
							text: 'Je wijzigingen zijn opgeslagen',
							color: 'success'
						});
						this.$vs.loading.close();
					}).catch(error => {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'Oops',
							text: 'Je wijzigingen zijn niet opgeslagen, controleer je gegevens en probeer het opnieuw',
							color: 'danger'
						});
					});
				} else {
					this.$vs.loading.close();
					this.$vs.notify({
						title: 'Oops',
						text: 'Je wijzigingen zijn niet opgeslagen, controleer je gegevens en probeer het opnieuw',
						color: 'danger'
					});
				}
			})
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.eboekhouden)
		}
	},
}
</script>

<style scoped>
.smallLabel {
	color: rgba(0, 0, 0, .7);
	padding-left: 5px;
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	font-size: .85rem;
}

ul {
	list-style-type: disc;
}
</style>
